// extracted by mini-css-extract-plugin
module.exports = {"root":"PageIntro_root__hE6kP","buttons":"PageIntro_buttons__rKSF_","caption":"PageIntro_caption__VHze_"};